import { z } from "zod";

// ---------------------------------------------------------------------------
// 誤って作った会社の削除（2026-10-14 射場さんの決定、#185、docs/74 §6。DB 20261015_0100）
//   作った本人（管理者）が、無料トライアル中で、データが空（顧客・案件・帳票が 0 件、ユーザーが本人だけ）のときだけ、
//   設定のメニューの一番下の「会社削除」ですぐに消せる（確認の窓あり。退会の 30 日の猶予とは別）。
//   条件を満たさないときはボタンを出さず、今の「退会」を出す。ログインはほかの会社（同じ製品）へ移る＝ほかに使える会社が要る
// ---------------------------------------------------------------------------

/** 消せないわけ（DB の fn_tenant_delete_check と、API が見る not_trial） */
export const CompanyDeleteReason = z.enum(["not_found", "not_active", "not_creator", "other_users", "has_data", "only_company", "not_trial"]);
export type CompanyDeleteReason = z.infer<typeof CompanyDeleteReason>;

/** GET /company/delete-check */
export const CompanyDeleteState = z.object({
  deletable: z.boolean(),
  reason: CompanyDeleteReason.nullable(),
});
export type CompanyDeleteState = z.infer<typeof CompanyDeleteState>;

export const COMPANY_DELETE_MSG = {
  /** 設定のメニューの一番下（朱）。「退会」の代わりに出す */
  row: "会社削除",
  note: "作成直後でデータがないため、すぐに削除できます。",
  title: "会社削除",
  body: (name: string) => `「${name}」を削除します。元に戻せません。`,
  cancel: "取消",
  submit: "削除",
  done: (name: string) => `「${name}」を削除しました`,
  /** API の断り（409）。画面は窓の中に1行 */
  reasons: {
    not_found: "この会社は見つかりません",
    not_active: "退会の手続き中の会社は削除できません",
    not_creator: "この会社の作成者（管理者）だけが削除できます",
    other_users: "ほかのユーザーがいる会社は削除できません。退会の手続きをしてください",
    has_data: "顧客・案件・帳票がある会社は削除できません。退会の手続きをしてください",
    only_company: "他にログインできる会社がないため削除できません。退会の手続きをしてください",
    not_trial: "無料トライアル中の会社だけ削除できます。退会の手続きをしてください",
  } satisfies Record<CompanyDeleteReason, string>,
} as const;
